export const environment = {
    //BACKEND SERVER
    //apiServerUrlReporter: "https://apptest1.smarcom.net/dashboard/",
    apiServerUrl: "https://dashboard-reporter.dev1.smarpay.eu/",
    apiEndpoint: "smarpay/api/v1",

    //NEW BACKEND SERVER
    newApiServerUrl: "https://management-backend-test.azurewebsites.net",

    //AZURE REPORTER BACKEND
    pgwReporter: 'https://pgwtest.smarcom.net',
    accessToken: `/api/v2/Account/Token`,
    getReportDefinitionList: '/Reporting/v1/ReportDefinitionList',
    getReport: '/Reporting/v1/GenerateReport',

    //MOCK VOUCHERS SERVER
    // "https://virtserver.swaggerhub.com/ZELJANALDUK/Voucher_Manager/0.0.1",
    //mockCampaignVoucherServer: "https://stoplight.io/mocks/aldotech/voucher-manager/192944060/merchants/f8b84024-33dd-4dcf-b3a8-a78b8f291863", 

    //REAL VOUCHER SERVER
    //campaignVoucherServer: "https://vouchers-backend.dev1.smarpay.eu",
    //campaignVoucherServer: "https://localhost:7034",


    //BACKEND URL
    securityInfoEndpoint: "/security-info",
    reportingCSVConvert: "/reporting/csv-convert",

    //PGW
    PGWSummaryBufferedEndpoint: "/pgw/transactions/summary-buffered",
    PGWTransactions2Endpoint: "/pgw/transactions2",
    PGWTransactionsSearchEndpoint: "/pgw/transactions/search",

    //PGW NEW BACKEND
    PGWSummaryBufferedEndpointNewEndpoint: "/transactions/summary",

    //MGW
    MGWMachineStatesBuffered2Endpoint: "/mgw/machine-states-buffered",

    //ONBOARDING
    CreateAccount: "smarpay/api/v1/accounts/public/create",


    //TRANSACTIONS
    getTransactionsV2: "transactions/v2",

    //CAMPAIGNS - VOUCHERS
    getMerchantsMethod: "/merchants",
    getCampaignsMethod: "/campaigns/all",
    postCampaignsMethod: "/campaigns",
    imageCampaignsMethod: "/image/campaign",
    getDashboardUserValidateMethod: "/dashboardUser/validate",

    //CAMPAIGNS - VOUCHERS -IMAGES
    getHeroImageEndpoint: "/image/campaign/hero/", ///image/campaign/hero/{campaignId},
    getVoucherImageEndpoint: "/image/campaign/voucher/", ///image/campaign/voucher/{campaignId}

    //DEVICES - ADD - DELETE - EDIT
    addDeviceEndpoint: "/AddMachines",
    machineGroupEndpoint: "/machineGroups",
    getAllMachines: "/GetAllMachines",
    deleteDevice: "/machines",
    putDevice: "/machines",

    //POS - ADD - DELETE - EDIT
    addPosDevices: "/AddPosDevices",
    getAllPosDevices: "/GetAllPosDevices",
    deletePosDevices: "/PosDevices",
    putPosDevices: "/PosDevices",

    //USER MANAGMENT
    getSuperAdminMerchantsMethod: "/userManagement/superadmin/merchants",
    getUserManagmentRolesMethod: "/userManagement/roles",
    getSuperAdminUsersMethod: "/userManagement/superAdmin/users",
    getAdminUsersMethod: "/userManagement/admin/users",
    postSuperAdminAssignUserMethod: "/userManagement/superAdmin/assignUser",
    deleteSuperAdminMerchantMethod: "/userManagement/superAdmin/unassignUser",
    putSuperAdminEditMethod: "/userManagement/superAdmin/edit",

    //OTHER    
    currency: process.env.REACT_CURRENCY || "CHF",

    KEYCLOAK_MOCK_SERVER: "https://57eb0d3f-638b-4781-9106-323d40e2a515.mock.pstmn.io",
    KEYCLOAK_ACCESS_TOKEN_VALIDITY: 300, //5min
    KEYCLOAK_AUTO_LOGOUT_TIMER: 15 * 60 * 1000, //15 minutes (adjust as needed)

    //FEATURES (ON-OFF)
    DEVICE_MANAGEMENT_FEATURE: true,
    USER_ROLE_MANAGEMENT_FEATURE: true,

    //TEST - TEMPORARY (REMOVE LATER)
    SUPERADMIN_TEST_MODE_ENABLED: false
}